import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { GlobalService } from './global.service';
import { HttpService } from './http.service';
import { formatDate } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})

export class DataFilterService {

  private facFilter = new Subject<any>();
  private requestFilter = new Subject<any>();
  chartArray: any = [];
  filteredData: any = {};
  allCustomers: any = [];
  calledonce: boolean = false;
  patients: number = 0;
  tests: number = 0;
  typeToFilter: any = [];
  excelData: any = [];
  isEnteredfunc: boolean = false
  availableCountriesList: any = []
  countriesTofilter: any[];
  availableDistributors: any = [];

  constructor(private httpService: HttpService, private _glob: GlobalService, private router: Router) {
    this.router.events
      .pipe(filter((rs): rs is NavigationEnd => rs instanceof NavigationEnd)).subscribe(event => {
        if (event.id === 1 && event.url === event.urlAfterRedirects) {
          this.filteredData = {}
        }
      })
  }

  updateDataFilter(facilityId, servicePersons) {
    for (let i = 0; i < this.filteredData.sortedArray.length; i++) {
      if (this.filteredData.sortedArray[i].id == facilityId) {
        this.filteredData.sortedArray[i].data.servicePersons = servicePersons;
      } else {
      }
    }

  }

  async changeFilter(facType, countries?, Distributors?, isRefresh?: boolean) {
    this.calledonce = true
    this.typeToFilter = [];
    this.typeToFilter = facType;
    var arraywithFacilityType: any = []
    var arraywithDistributorFilter: any = []
    this.countriesTofilter = countries
    var distributors = Distributors
    var firstFacilityOndate;
    this.chartArray = []
    var count: any = 0;
    this.patients = 0;
    this.tests = 0;
    var length = 0
    var isundefined = false
    if (this.typeToFilter.length >= this.countriesTofilter.length) {
      length = this.typeToFilter.length
    } else {
      length = this.countriesTofilter.length
    }
    // var event:any = []
    for (var key in this.filteredData) {
      // this check can be safely omitted in modern JS engines
      // if (obj.hasOwnProperty(key))
      delete this.filteredData[key];
    }
    if (this.allCustomers.length == 0 || isRefresh) {
      this.isEnteredfunc = true;
      this.allCustomers = []
      await this.httpService.getallCustomers().then((numbs) => {
        console.log("Data filter");
        
        this.allCustomers = numbs;
      });
    }

    this.allCustomers.forEach(element => {
      if (element.data.creationTime < firstFacilityOndate || firstFacilityOndate == undefined) {
        // console.log("true",new Date(firstFacilityOndate),new Date(element.data.creationTime));
        firstFacilityOndate = element.data.creationTime
      }
      for (let index = 0; index < this.typeToFilter.length; index++) {
        
        if (element.data.customerType == this.typeToFilter[index]) {
          if (this.countriesTofilter.length > 0) {
            arraywithFacilityType.push(element)
          } else {
            if (element.data.customerType == undefined || element.data.customerType == null) {
              count++;
              this.patients += element.data.patientCount
              this.tests += element.data.testCount
              arraywithFacilityType.push(element);
            }
          }
        }
      }
    });

    arraywithFacilityType.forEach(facility => {
      for (let index = 0; index < this.countriesTofilter.length; index++) {
        const element = this.countriesTofilter[index];
        if (facility.data.country != undefined) {
          if (facility.data.country == element) {
            // count++;
            // this.patients += facility.data.patientCount
            // this.tests += facility.data.testCount
            // this.chartArray.push(facility);
            arraywithDistributorFilter.push(facility)
          }
        } else {
          if (facility.data.country == undefined && element == "No Settings") {
            count++;
            this.patients += facility.data.patientCount
            this.tests += facility.data.testCount
            arraywithDistributorFilter.push(facility);
          }
        }
      }
    });
    this.patients = 0
    this.tests = 0
    this.chartArray = []
    count = 0
    arraywithDistributorFilter.forEach(distributorsFac => {
      if (distributorsFac.data.distributer != undefined) {


        if (distributors.length > 0) {
          for (let index = 0; index < distributors.length; index++) {
            const element = distributors[index];
            if (distributorsFac.data.distributer == element) {

              count++;
              this.patients += distributorsFac.data.patientCount
              this.tests += distributorsFac.data.testCount
              this.chartArray.push(distributorsFac);
            }
          }
        }
      } else {
        count++;
        this.patients += distributorsFac.data.patientCount
        this.tests += distributorsFac.data.testCount
        this.chartArray.push(distributorsFac);
      }
    });
    if ((!isRefresh || isRefresh == undefined) && (!this.isEnteredfunc)) {
      this.isEnteredfunc = true
    }

    this.filteredData = {
      facilities: count,
      patients: this.patients,
      tests: this.tests,
      sortedArray: this.chartArray,
    }
    this.isEnteredfunc = false;
    this.getFilteredCustomerData();

    if (this.router.url.toString().includes('requests')) {
      this.filterRequests();
    }
    this.facFilter.next(this.filteredData);
  }

  getcountryList() {
    var allCountries: any = []
    this.allCustomers.forEach(element => {
      if (element.data.country == null) {
        allCountries.push("No Settings")

      } else {
        allCountries.push(element.data.country)
      }
    });
    let uniqueCountries = allCountries.filter((c, index) => {
      return allCountries.indexOf(c) === index;
    });
    this.availableCountriesList = uniqueCountries
    return this.availableCountriesList
  }

  getdistributorList() {

    var allDistributors: any = []
    this.allCustomers.forEach(element => {
      if (element.data.distributer == null || element.data.distributer == undefined) {
        allDistributors.push("No Settings")
      } else {
        allDistributors.push(element.data.distributer)
      }
    });
    let uniqueDistributers = allDistributors.filter((c, index) => {
      return allDistributors.indexOf(c) === index;
    });
    this.availableDistributors = uniqueDistributers

    return uniqueDistributers
  }

  onUpdateFilter(): Observable<any> {
    return this.facFilter.asObservable();
  }

  onUpdateRequestFilter(): Observable<any> {
    return this.requestFilter.asObservable();
  }

  getFilteredCustomerData() {
    this.excelData = [];
    var lastSignInTimee, creationTimee;
    var browser;
    var screen_height;
    var screen_width;
    for (let i = 0; i < this.chartArray.length; i++) {
      try {
        creationTimee = formatDate(this.chartArray[i].data.creationTime.toDate(), 'dd-MMM-yyyy', 'en');
      } catch {
        creationTimee = "";
      }

      try {
        lastSignInTimee = formatDate(this.chartArray[i].data.lastSignInTime.toDate(), 'dd-MMM-yyyy', 'en');
      } catch {
        lastSignInTimee = "";
      }
      try {
        browser = this.chartArray[i].data.deviceInfo.browser;
        screen_height = this.chartArray[i].data.deviceInfo.screen_height;
        screen_width = this.chartArray[i].data.deviceInfo.screen_width;
      } catch {
        browser = "";
        screen_height = "";
        screen_width = "";
      }
      var totSalesPerson;
      if (this.chartArray[i].data.servicePersons == [] || this.chartArray[i].data.servicePersons == null || this.chartArray[i].data.servicePersons == undefined) {
        totSalesPerson = 0;
      } else {
        totSalesPerson = this.chartArray[i].data.servicePersons.length;
      }
      this.excelData.push({
        id: this.chartArray[i].id,
        facilityId: this.chartArray[i].id,
        facilityName: this.chartArray[i].data.facilityName,
        country: this.chartArray[i].data.country,
        city: this.chartArray[i].data.city,
        clientIp:this.chartArray[i].data.clientIP,
        customerType: this.chartArray[i].data.customerType,
        //distributor: this.chartArray[i].data.distributor,
        noSalesperson: totSalesPerson,
        designation: this.chartArray[i].data.designation,
        deviceSN: this.chartArray[i].data.deviceSN,
        doctorName: this.chartArray[i].data.doctorName,
        email: this.chartArray[i].data.email,
        lastSignInTime: lastSignInTimee,
        creationTime: creationTimee,
        patientCount: this.chartArray[i].data.patientCount,
        phone: this.chartArray[i].data.phone,
        streetNo: this.chartArray[i].data.streetNo,
        testCount: this.chartArray[i].data.testCount,
        requestCount: this.chartArray[i].data.requestCount,
        qcTestCount: this.chartArray[i].data.qcTestCount,
        testCredits: this.chartArray[i].data.testCredits,
        zipCode: this.chartArray[i].data.zipCode,
        optional1: this.chartArray[i].data.optional1,
        optional2: this.chartArray[i].data.optional2,
        website: this.chartArray[i].data.website,
        photoURL: this.chartArray[i].data.photoURL,
        logoURL: this.chartArray[i].data.logoURL,
        concentrationStd: this.chartArray[i].data.testSettings.concentrationStd,
        testOptional1: this.chartArray[i].data.testSettings.testOptional1,
        testOptional2: this.chartArray[i].data.testSettings.testOptional2,
        who: this.chartArray[i].data.testSettings.who,
        browser: browser,
        totalCredits: this.chartArray[i].data.totalCredits,
        screen_height: screen_height,
        screen_width: screen_width,
      });
      this._glob.filteredExportData = this.excelData;
    }

  }

  async filterRequests() {
    let filteredRequests = [];
    await this.httpService.getAllRequests().then(allRequests => {
      let filteredFacIds = [];
      console.log("this.filteredData.sortedArray", this.filteredData.sortedArray);
      if (this.filteredData.sortedArray != undefined) {
        this.filteredData.sortedArray.forEach(facility => {
          filteredFacIds.push(facility.id);
        });
      }
      // console.log('requests facilityids ', filteredFacIds);
      filteredRequests = allRequests.filter(r => filteredFacIds.includes(r.data.facilityId));
    });
    this.requestFilter.next(await filteredRequests);
  }
}
